/* eslint-disable react/prop-types */
import { useState, useEffect } from "react";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { X } from "lucide-react";
import { Separator } from "../ui/separator";
import { Button } from "../ui/button";

const OurBankDetails = ({
  open,
  setOpen,
  user,
  amount,
  setShowDrawer,
  accountDetails,
}) => {
  const formatter = new Intl.NumberFormat("en-US");

  return (
    <div>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent className="font-jakarta dark:bg-darkBg w-full max-w-[600px] border-none bg-white">
          <AlertDialogHeader className="pt-4">
            <AlertDialogTitle className="text-darkInput text-xl font-bold dark:text-white">
              <div className="flex items-center justify-between pt-5 pb-5">
                <h1>Bank Account Details</h1>
                <h2 className="rounded-md bg-[#54d62c29] p-1 text-xs font-bold text-[#229a16]">
                  Billzpay
                </h2>
              </div>
              <Separator />
            </AlertDialogTitle>
          </AlertDialogHeader>

          <div className="dark:bg-darkInput rounded-xl bg-gray-100 p-6 text-sm dark:text-gray-200">
            <h2 className="pb-2">
              Dear <strong>{user?.name}</strong>,
            </h2>
            <p className="py-2">
              To fund your wallet, kindly pay{" "}
              <strong>₦{formatter.format(amount)}</strong> into the bank account
              below through bank deposit/transfer, online transfer, mobile app
              transfer, etc.
            </p>
            <Separator className="my-4" />
            <h3 className="py-1">Bank Account Details:</h3>
            <p className="flex items-center gap-2">
              <strong className="min-w-[120px]">Account Name:</strong>
              <span className="text-primary font-bold uppercase">
                {user.meta_data.manual_funding_account_name}
              </span>
            </p>
            <p className="flex items-center gap-2">
              <strong className="min-w-[120px]">Account Number:</strong>
              <span className="text-primary font-bold">
                {user.meta_data.manual_funding_account_number}
              </span>
            </p>
            <p className="flex items-center gap-2">
              <strong className="min-w-[120px]">Bank Name:</strong>
              <span className="text-primary font-bold uppercase">
                {user.meta_data.manual_funding_bank}
              </span>
            </p>{" "}
            <Separator className="my-4" />
            <p>
              After making the payment,
              <br />
              <Button
                onClick={() => {
                  setOpen(false);
                  setShowDrawer(true);
                }}
                className="my-2 text-white"
              >
                please fill out the payment details form
              </Button>
              <br />
              and your wallet will be credited once the payment is confirmed.
            </p>
            <Separator className="my-4" />
            <h3>Support:</h3>
            <p>
              If you have any questions or need assistance, please contact us:
            </p>
            <p>
              <strong>Email:</strong>{" "}
              <a href="mailto:support@billzpay.com.ng">
                support@billzpay.com.ng
              </a>
            </p>
          </div>

          <div
            onClick={() => {
              setOpen(false);
            }}
            className="absolute top-4 right-4 cursor-pointer rounded-sm border p-1"
          >
            <X className="size-5 text-black dark:text-white" />
            <span className="sr-only">Close</span>
          </div>
        </AlertDialogContent>
      </AlertDialog>

      {/* User Info Drawer */}
    </div>
  );
};
export default OurBankDetails;
